import '../app/styles/main.scss';

import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { RequireAuth } from '@/shared/lib';
import { Loading } from '@/shared/ui';

import { BaseLayout } from '../layouts/base-layout';
import { privateRoutes } from './routes.tsx';

const Routing = () => {
  return (
    <Routes>
      <Route element={<BaseLayout />}>
        {privateRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <Suspense fallback={<Loading visible />}>
                <RequireAuth>{Component}</RequireAuth>
              </Suspense>
            }
          />
        ))}
      </Route>
      {/*<Route>*/}
      {/*  {publicRoutes.map(({ path, Component }) => (*/}
      {/*    <Route*/}
      {/*      key={path}*/}
      {/*      path={path}*/}
      {/*      element={*/}
      {/*        <Suspense fallback={<div>...Loading</div>}>*/}
      {/*          <Component />*/}
      {/*        </Suspense>*/}
      {/*      }*/}
      {/*    />*/}
      {/*  ))}*/}
      {/*</Route>*/}
    </Routes>
  );
};

export default Routing;
